export default __webpack_public_path__ + "static/media/6.67e027fd.jpg";